import * as actionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default function getMessageListReducer(
  state = initialState.messageList,
  action
) {
  switch (action.type) {
    case actionTypes.GET_MESSAGES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
